import React, { useMemo } from 'react';
import { Box, HStack, Text } from '@design-system/pc';
import LoadImage from '@/components/LoadImage';
import styled from 'styled-components';
import useRecentGoodsButton from './hooks/useRecentGoodsButton';
import TrackingService from '@/services/tracking';

interface RecentGoodsButtonProps {
  isShowTopButton: boolean;
}

const FOLDED_WIDTH = 80;
const OPEN_WIDTH = 181;
const BORDER_RATIO = 18 / 35;

const RecentGoodsButton = ({ isShowTopButton }: RecentGoodsButtonProps) => {
  const { recentGdsImageUrl, isOpenRecentBanner, handleGoRecentGoodsPage } =
    useRecentGoodsButton();

  const computedBorderRadius = useMemo(() => FOLDED_WIDTH * BORDER_RATIO, []);

  return (
    <>
      {recentGdsImageUrl && (
        <RecentGoodsWrapper
          overflow="hidden"
          width={isOpenRecentBanner ? `${OPEN_WIDTH}px` : `${FOLDED_WIDTH}px`}
          borderRadius={computedBorderRadius}
          boxShadow="0px 2px 4px 0px rgba(0, 0, 0, 0.15)"
          onClick={handleGoRecentGoodsPage}
          zIndex={1}
          isShowTopButton={isShowTopButton}
          {...TrackingService.tagGTM('recent_goods_floating_button')}
        >
          <HStack
            width={OPEN_WIDTH}
            height={FOLDED_WIDTH}
            backgroundColor="color_chip.primary"
            pl={16}
          >
            <Text variant="headline5" color="color_chip.white">
              최근 본 상품
            </Text>
          </HStack>
          <Box
            width={FOLDED_WIDTH}
            height={FOLDED_WIDTH}
            backgroundColor="color_chip.primary"
            border="2px solid"
            borderColor="color_chip.primary"
            overflow="hidden"
            borderRadius={computedBorderRadius}
            position="absolute"
            top="0"
            right="0"
          >
            <LoadImage
              src={recentGdsImageUrl}
              w={FOLDED_WIDTH}
              h={FOLDED_WIDTH}
              c={true}
            />
          </Box>
        </RecentGoodsWrapper>
      )}
    </>
  );
};

const RecentGoodsWrapper = styled(Box)<{ isShowTopButton: boolean }>`
  position: absolute;
  right: 0;
  bottom: ${({ isShowTopButton }) => (isShowTopButton ? '62px' : 0)};
  transition: bottom 0.4s ease, width 0.3s;
  cursor: pointer;

  &:hover {
    width: ${OPEN_WIDTH}px;
  }
`;

export default RecentGoodsButton;
